import { ICICILombard } from '@prishapolicy/w3/assets';
import { Fire } from './fire';
import { Health } from './health';

import { insurerLogos } from './constants';
import { Engineering } from './engineering';
import { ResourceDataType } from './resourcedatatypes';

// type ResourceArrayType = {
//   type: string;
//   data: ResourceProductType;
// };

export const resources = [
  { type: 'engineering-insurance', data: Engineering },
  { type: 'fire-insurance', data: Fire },
  { type: 'health-insurance', data: Health },
] as const;

export const getFlattenedResourceData = () => {
  const resourceData: ResourceDataType[] = [];

  resources.forEach((resource) => {
    Object.keys(resource.data).forEach((insurer) => {
      Object.keys(resource.data[insurer]).forEach((product) => {
        resource.data[insurer][product].forEach((data) => {
          const resources: ResourceDataType = {
            name: product,
            resourceCategory: data.formType,
            resourceLink: data.formLink,
            insuranceCategory: resource.type,
            product: product,
            image: insurerLogos[insurer] ? insurerLogos[insurer] : ICICILombard,
            description: data.description
              ? data.description
              : `This is the ${data.formType} for ${product} under ${resource.type} category by ${insurer}.`,
            brand: insurer,
          };
          resourceData.push(resources);
        });
      });
    });
  });

  return resourceData;
};
